import React, {
  useState, useEffect, useCallback, useRef,
} from 'react';
import PropTypes from 'prop-types';

import { withTutorshipUpdateContext } from './tutorshipUpdateContext';
import { withAsync } from '../common/withAsync';
import { updateGrowthTrackerScore } from './api';
import { TestShape, ScoreShape } from './shapes';
import ScoreForm from './score_form/scoreForm';

const EditScoreFormContainer = ({
  test, growthTrackerId, invoke, data, editMode, score, updateTutorshipWithMessage, closeModal,
}) => {
  const scoreContainer = useRef({});
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    scoreContainer.current = { ...scoreContainer.current, scoreId: score.id };
  }, [score, scoreContainer]);

  useEffect(
    () => {
      if (data && data.success) {
        setErrorMessage('');
        closeModal();
        updateTutorshipWithMessage('Growth tracker score updated successfully.');
      } else {
        setErrorMessage(data.error);
      }
    },
    [closeModal, data, editMode, updateTutorshipWithMessage],
  );

  const submitAfterValidation = () => {
    invoke({
      ...scoreContainer.current,
      growthTrackerId,
    });
  };

  const updateScore = useCallback((updatedScore) => {
    scoreContainer.current = { ...scoreContainer.current, ...updatedScore };
  }, [scoreContainer]);

  return (
    <ScoreForm
      errorMessage={errorMessage}
      updateScore={updateScore}
      existingScore={score}
      editMode={editMode}
      closeModal={closeModal}
      submitAfterValidation={submitAfterValidation}
      test={test}
    />
  );
};

EditScoreFormContainer.defaultProps = {
  data: {},
  editMode: false,
};

EditScoreFormContainer.propTypes = {
  test: PropTypes.shape(TestShape).isRequired,
  growthTrackerId: PropTypes.number.isRequired,
  invoke: PropTypes.func.isRequired,
  data: PropTypes.shape({
    success: PropTypes.string,
    error: PropTypes.string,
  }),
  editMode: PropTypes.bool,
  score: PropTypes.shape(ScoreShape).isRequired,
  updateTutorshipWithMessage: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default withTutorshipUpdateContext(withAsync(EditScoreFormContainer,
  updateGrowthTrackerScore,
  false));
